import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "iframe-wrapper" }
const _hoisted_2 = { class: "gameBar" }
const _hoisted_3 = { class: "iframe-container" }
const _hoisted_4 = ["src"]

import { getGameUrl } from '@/api/game'
import StatusPopup from '@/components/common/statusPopup.vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GameHeadBar from './component/gameHeadBar.vue'
import { notifyEmbeddedGameResize, toggleFavorite } from './supportScript'
import { useUserStore } from '@/stores/user'
import { useGameStore } from '@/stores/games'
import LoadingScreen from '@/components/common/loadingScreen.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'gameView',
  setup(__props) {

const router = useRouter()
const route = useRoute();
const GameType = ref<any>(route.query.game_type);
const gameMakerID = ref(route.query.game_maker);
const favId = ref<any>(route.query.fav_id)
const userStore = useUserStore()
const gameStore = useGameStore()
const isFavorite = ref(false)
const favoriteStatus = ref<any>('')
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const iframeUrl = ref("")
const loadingRef = ref()
const gameIframeRef = ref<HTMLIFrameElement>()

const navToback = () => {
    router.go(-1)
}

const onIframeLoad = () => {
    notifyEmbeddedGameResize(gameIframeRef.value)
    setTimeout(() => notifyEmbeddedGameResize(gameIframeRef.value), 200)
    setTimeout(() => notifyEmbeddedGameResize(gameIframeRef.value), 800)
}

const handleParentResize = () => {
    notifyEmbeddedGameResize(gameIframeRef.value)
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const gameUrl = () => {
    loadingRef.value.open()
    let params = {
        gameId: GameType.value,
        gameMakerId: gameMakerID.value
    }
    getGameUrl(params).then(res => {
        let resData = res?.data
        iframeUrl.value = resData?.game_url || ''
        loadingRef.value.close()
    }).catch(err => {
        showError(err);
        loadingRef.value.close()
    })
}

const addToFavorite = () => {
    toggleFavorite({
        userId: userStore.id,
        gameId: favId.value,
        currentStatus: favoriteStatus.value,
        loadingRef,
        onSuccess: (status, msg) => {
            favoriteStatus.value = status
            isFavorite.value = favoriteStatus.value == '1' ? true : false
            gameStore.getGameGroupListData();
        },
        onError: (msg) => {
            showError(msg)
        }
    });
}

onMounted(() => {
    gameUrl()
    favoriteStatus.value = route.query?.favorite
    isFavorite.value = favoriteStatus.value == '1' ? true : false
    window.addEventListener('resize', handleParentResize)
    window.addEventListener('orientationchange', handleParentResize)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleParentResize)
    window.removeEventListener('orientationchange', handleParentResize)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(GameHeadBar, {
          onBackClick: navToback,
          "is-favorite": isFavorite.value,
          onAddFavorite: addToFavorite
        }, null, 8, ["is-favorite"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (iframeUrl.value)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              ref_key: "gameIframeRef",
              ref: gameIframeRef,
              src: iframeUrl.value,
              frameborder: "0",
              allow: "autoplay",
              scrolling: "no",
              onLoad: onIframeLoad
            }, null, 40, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})